var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortByTableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 5L5.83301 9.16667H14.1663L9.99967 5ZM5.83301 10.8333L9.99967 15L14.1663 10.8333H5.83301Z",
    fill: "#B2B2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortByTableIcon);
export default __webpack_public_path__ + "static/media/SortByTableIcon.6f4cff5c3049496096807105aec9b520.svg";
export { ForwardRef as ReactComponent };